import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  const location = useLocation(); // Get current route location

  // Log the token to the console (if any)
  console.log('Token:', token);

  if (!token) {
    // Redirect to login page with state to remember the previous page
    return (
      <Navigate
        to="/login"
        state={{ message: 'You must log in to access this page.', from: location.pathname }}
        replace
      />
    );
  }

  // If authenticated, render the child components (protected content)
  return children;
};

export default ProtectedRoute;
